import {createFileRoute} from '@tanstack/react-router';
import {companyAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import InactiveCompany from '@/practitioner/views/company/InactiveCompany';

export const Route = createFileRoute('/(practitioner)/company/inactive-company')({
  component: InactiveCompany,
  beforeLoad: grantUser(companyAdminGranted)
});
